import GeneralConditions from './components/footer/GeneralConditions';
import TermsAndConditions from './components/footer/TermsAndConditions';
import formasDePago from './components/formas-de-pago/formas-de-pago';
import ConsultaDetalle from './components/layout/consulta-detalle/formulario-consulta-detalle';
import MapAgencies from './components/map-agencies/map-agencies';
import Reclamos from './components/reclamos/reclamos';
import { ROUTE_KEYS } from './constants';
import UnifiedLayout from './components/layout/UnifiedLayout';
import BannerDetail from './views/banner-detalle/BannerDetail';
import CustomSection from './views/custom-section/custom-section';
import HomeView from './views/HomeView';
import PackageDetail from './views/paquete-detalle/PackageDetail';
import InternalPackageDetail from './views/paquete-detalle/InternalPackageDetail';
import PackageListPage from './views/paquetes/pages/PackageListPage';
import FlightListPage from './views/vuelos/pages/FlightListPage';
import BookingPageWrapper from './components/flights/Booking/BookingPageWrapper';
import formularioArrepentimiento from './components/layout/layout-arrepentimiento/formulario-arrepentimiento';
import withSearcherValidation from './hoc/withSearcherValidation';

const {
  HOME,
  BUSCAR_X_PAQUETES,
  BUSCAR_X_VUELOS,
  CONSULTA,
  CONSULTA_DETALLE,
  PAQUETE,
  BUSCAR_X_VUELOS_RESERVA,
  PAQUETES,
  AGENCIES,
  CLAIMS,
  PAY_METHODS,
  GENERAL_CONDITIONS,
  TERMS_AND_CONDITIONS,
  ARREPENTIMIENTO,
  CUSTOM_SECTION,
} = ROUTE_KEYS;

export const withLayout = (Component, options = {}) => {
  const { showSearchBar = false } = options;

  return (props) => (
    <UnifiedLayout showSearchBar={showSearchBar}>
      <Component {...props} />
    </UnifiedLayout>
  );
};

const routes = [
  {
    path: HOME,
    exact: true,
    component: withLayout(HomeView),
  },
  {
    path: BUSCAR_X_PAQUETES,
    exact: true,
    component: withLayout(withSearcherValidation(PackageListPage), {
      showSearchBar: true,
    }),
  },
  {
    path: BUSCAR_X_VUELOS,
    exact: true,
    component: withLayout(withSearcherValidation(FlightListPage), {
      showSearchBar: true,
    }),
  },
  {
    path: BUSCAR_X_VUELOS_RESERVA,
    exact: true,
    component: withLayout(withSearcherValidation(BookingPageWrapper)),
  },
  {
    path: ARREPENTIMIENTO,
    component: withLayout(formularioArrepentimiento),
  },
  {
    path: GENERAL_CONDITIONS,
    component: withLayout(GeneralConditions),
  },
  {
    path: TERMS_AND_CONDITIONS,
    component: withLayout(TermsAndConditions),
  },
  {
    path: CLAIMS,
    component: withLayout(Reclamos),
  },
  {
    path: `${CUSTOM_SECTION}/:id`,
    component: withLayout(CustomSection),
  },
  {
    path: AGENCIES,
    component: withLayout(MapAgencies),
  },
  {
    path: PAY_METHODS,
    component: withLayout(formasDePago),
  },
  {
    path: `${CONSULTA}/:id`,
    component: withLayout(BannerDetail),
  },
  {
    path: `${CONSULTA_DETALLE}/:id`,
    component: withLayout(ConsultaDetalle),
  },
  {
    path: `${PAQUETE}/:id`,
    component: withLayout(PackageDetail),
  },
  {
    path: PAQUETES,
    component: withLayout(InternalPackageDetail),
  },
];

export default routes;
